import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {useStockStorage} from "../../hooks/useStockStorage";
import {toast} from "react-custom-alert";
import {useTranslation} from "react-i18next";

const MissingReceipt = ({customToken, ...props}: ModalProps)  => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const {removeStockStorageToken} = useStockStorage();
    const {renewAppUniqueToken} = useAppUniqueToken();
    const handleConfirm = () => {
        const payload = new FormData();
        payload.append("uaToken", customToken);

        //alert("pospone-stock");
        //alert(payload);

        axios.post('/api/postpone-stock', payload, {
            headers: {"Content-Type": "multipart/form-data"}
        })
            .then(response => {

                removeStockStorageToken();
                renewAppUniqueToken();
                
                if(location.pathname === '/summary')
                    navigate('/lounge');
                else
                    navigate('/');

            }).catch(error => {
                console.log(error);
                toast.error(t('messages.defaultErrorMessage'));
        });
    };


    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <h4><b>{t('captions.warning')}</b></h4> <br />
                Per poter inviare le richieste di tesseramento è necessario allegare la ricevuta del pagamento già effettuato.<br /><br />
                In caso sia sprovvisto della ricevuta, o voglia caricarla in un secondo momento, clicchi su "Salva per dopo" e sarà
                reindirizzato alla sua area utente dove potrà in ogni momento caricare l'allegato e perfezionare l'invio delle richieste a Europa Verde.<br /><br />
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn_1 green" onClick={handleConfirm}>{t('captions.postponeSave')}</button>
                <button type="button" className="btn_1 yellow" onClick={props.onHide}>{t('captions.cancel')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default MissingReceipt;
